<!-- Presentational component to display a single cart item from the price book. -->
<template>
	<div
		v-if="plan && cartItem && cartItem.lineItem"
		:class="{ 'border-b border-slate-200 pb-3': isPackage }"
	>
		<SwipeableToggle
			target-class="print:my-2 hover:bg-primary-50"
			:model-value="!cartItem.isSoftDeleted"
			@update:model-value="$emit('delete')"
		>
			<div
				class="flex w-full items-start gap-4 overflow-hidden"
				:class="{
					'is-negative-price': cartItem.price && cartItem.price < 0,
					'print:grid-cols-[minmax(0,1fr)_max-content]': true,
				}"
			>
				<div
					class="flex-1 self-center text-sm"
					:class="{
						'font-semibold text-slate-400': isPackage,
						'text-primary-700 font-bold': !isPackage,
					}"
				>
					{{ cartItem.lineItem?.name }}
				</div>
				<CartPrice
					:cartItem="cartItem"
					:plan="plan"
					:isPackage="isPackage"
					class="ml-auto max-w-[30%]"
				/>
			</div>
		</SwipeableToggle>
	</div>
</template>

<script setup lang="ts">
import CartPrice from './CartPrice.vue'
import Plan from '@/classes/Plan'
import SwipeableToggle from '@/components/common/SwipeableToggle.vue'
import {
	type CartItemAndLineItem,
	type CartSubItemAndLineItem,
} from '@/mixins/merchandise'
import type { PropType } from 'vue'

defineProps({
	plan: Object as PropType<Plan>,
	cartItem: Object as PropType<CartItemAndLineItem | CartSubItemAndLineItem>,
	isPackage: Boolean,
})

defineEmits(['delete'])
</script>
